import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Active } from '../entities/active';
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class ActiveService {
  // Define API
  apiURL = environment.apiUrl;

  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // HttpClient API get() method => Fetch active list
  getAllActives(): Observable<Active> {
    return this.http.get<Active>(this.apiURL + '/getformulariocaptura')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }


  // HttpClient API get() method => Fetch active
  getActive(id): Observable<Active> {
    return this.http.get<Active>(this.apiURL + '/formulario_captura/' + id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API post() method => Create active
  createActive(active): Observable<Active> {
    return this.http.post<Active>(this.apiURL + '/formulario_captura/0', JSON.stringify(active), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getActivesFilter(filters): Observable<Active> {
    return this.http.post<Active>(this.apiURL + '/pBuscarFormularioCaptura', JSON.stringify(filters), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  createCapture(capture): Observable<Active>{
    return this.http.post<Active>(this.apiURL + '/formulario_captura_campo/0', JSON.stringify(capture), this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // HttpClient API put() method => Update active
  updateActive(id, active): Observable<Active> {
    return this.http.put<Active>(this.apiURL + '/formulario_captura/' + id, JSON.stringify(active), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API delete() method => Delete active
  deleteActive(id) {
    return this.http.delete<Active>(this.apiURL + '/formulario_captura/' + id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error) {
    let errorMessage = 'Intente nuevamente';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Codigo Error (captura): ${error.status} Message: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
